import React, { useState, useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import axios from "axios";
import { apiRoutes } from '../../AppSettings';
import { Form } from 'react-bootstrap';
import Spinner from '../shared/Spinner';

const Register = () => {

	const history = useHistory();
	const { updateUserState } = useContext(AuthContext);
	const [registerData, setRegisterData] = useState({
		email: '',
		password: '',
		phone: '',
		breed: '',
		role: 'Patient',
		firstName: '',
		lastName: ''
	});

	const [showSpinner, setShowSpinner] = useState(false);
	
	const handleSubmit = e => {
		e.preventDefault();
		setShowSpinner(true);
		const options = {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		};

		axios.post(apiRoutes.registerPatient, JSON.stringify(registerData), options)
			.then((response) => {
				if (response.status === 200) {
					setShowSpinner(false);
					const data = response.data;
					updateUserState(data.token, data.userDetail, true, data.roles[0], data.loggedInUser);
					history.push('/patientdashboard');
				}
			}, (error) => {
				console.log(error);
			});
	};

	return (
		<div class="content">
			 <Spinner show={showSpinner}/> 
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-8 offset-md-2">
						<div class="account-content">
							<div class="row align-items-center justify-content-center">
								<div class="col-md-7 col-lg-6 login-left">
									<img src="assets/img/login-banner.png" class="img-fluid" alt="Vetville Register" />
								</div>
								<div class="col-md-12 col-lg-6 login-right">
									<div class="login-header">
										<h3>Patient Register <Link to={'/doctorregister'}>Are you a Doctor?</Link> </h3>
									</div>
									<Form onSubmit={(e) => handleSubmit(e)}>
										<div className="row">
											<div className="col-md-6">
												<div className="form-group form-focus">
													<input
														type="text"
														className="form-control floating"
														required
														onChange={e => setRegisterData({ ...registerData, firstName: e.target.value })} />
													<label className="focus-label">First Name</label>
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group form-focus">
													<input
														type="text"
														className="form-control floating"
														required
														onChange={e => setRegisterData({ ...registerData, lastName: e.target.value })} />
													<label className="focus-label">Last Name</label>
												</div>
											</div>
										</div>
										<div className="form-group form-focus">
											<input
												type="email"
												className="form-control floating"
												required
												onChange={e => setRegisterData({ ...registerData, email: e.target.value })} />
											<label className="focus-label">Email</label>
										</div>
										<div className="form-group form-focus">
											<input
												type="text"
												className="form-control floating"
												required
												onChange={e => setRegisterData({ ...registerData, phone: e.target.value })} />
											<label className="focus-label">Mobile</label>
										</div>
										{/*<div className="form-group form-focus">*/}
										{/*	<select className="form-control select" onChange={e => setRegisterData({ ...registerData, breed: e.target.value })}>*/}
										{/*		<option>--Select Breed--</option>*/}
										{/*		<option>Dog</option>*/}
										{/*		<option>Cat</option>*/}
										{/*	</select>*/}
										{/*</div>*/}
										<div className="form-group form-focus">
											<input
												type="password"
												className="form-control floating"
												required
												onChange={e => setRegisterData({ ...registerData, password: e.target.value })} />
											<label className="focus-label">Create Password</label>
										</div>
										<div class="text-right">
											<Link className="forgot-link" to={'/'}>Already have an account?</Link>
										</div>
										<button type="submit" class="btn btn-primary btn-block btn-lg login-btn">Signup</button>
										<div class="login-or">
											<span class="or-line"></span>
											<span class="span-or">or</span>
										</div>
										<div class="row form-row social-login">
											<div class="col-6">
												<a href="#" class="btn btn-facebook btn-block"><i class="fab fa-facebook-f mr-1"></i> Login</a>
											</div>
											<div class="col-6">
												<a href="#" class="btn btn-google btn-block"><i class="fab fa-google mr-1"></i> Login</a>
											</div>
										</div>
									</Form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Register;
